import { render, staticRenderFns } from "./ArchivesContractInfo.vue?vue&type=template&id=060d1ea8&scoped=true&"
import script from "./ArchivesContractInfo.vue?vue&type=script&lang=js&"
export * from "./ArchivesContractInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d1ea8",
  null
  
)

export default component.exports